import { apiClient } from '@shared/api';
import type { ApiResponse } from '@shared/types';
import type { GeminiConfig, UpdateGeminiConfigRequest } from '../types';

class ConfigurationService {
  private readonly baseUrl = '/configuration';

  async getGeminiConfig(): Promise<GeminiConfig> {
    const { data } = await apiClient.get<ApiResponse<GeminiConfig>>(`${this.baseUrl}/gemini`);
    if (data.success && data.data) return data.data;
    throw new Error(data.message || 'Failed to fetch Gemini config');
  }

  async updateGeminiConfig(payload: UpdateGeminiConfigRequest): Promise<GeminiConfig> {
    const { data } = await apiClient.put<ApiResponse<GeminiConfig>>(
      `${this.baseUrl}/gemini`,
      payload,
    );
    if (data.success && data.data) return data.data;
    throw new Error(data.message || 'Failed to update Gemini config');
  }
}

export const configurationService = new ConfigurationService();
